  export const initialValuesExperienciasmodel = {
    index: 0,
    nombre_convocatoria: "",
    entidad: "",
    ciudad: "",
    anio: "",
    area: "",
    documento: ""
  };
  
  
  export interface ExperienciaModel {
    index: number,
    nombre_convocatoria: string,
    entidad: string,
    ciudad: string,
    anio: string,
    area: string,
    documento: string
  }

  export interface AreasModel {
    id_area: number,
    nombre_area: string,
    categorias_areas: string,
  }
  
    
  